"use client"

import { useLanguage } from '@/i18n/LanguageProvider'
import { appLanguageToContentLocale } from '@/i18n/contentLocale'
import { Link } from 'react-router-dom'
import '@/styles/bauhaus.css'

export default function PoetClient({ poet, groupId }: { poet: any, groupId: string }) {
  const { t, language } = useLanguage()
  const poetLang = appLanguageToContentLocale(language)

  if (!poet) return <div>Poet not found</div>

  // 标题选择逻辑
  const getOriginalTitle = (poem: any) => {
    const lang = poem.language?.original;
    return (
      (lang && poem.title?.[lang]) ||
      poem.title?.original ||
      poem.title?.zh ||
      poem.title?.de ||
      poem.title?.en ||
      ''
    );
  };
  const getTranslationTitle = (poem: any) => {
    const lang = poem.language?.translation;
    return (
      (lang && poem.title?.[lang]) ||
      poem.title?.translation ||
      poem.title?.de ||
      poem.title?.zh ||
      poem.title?.en ||
      ''
    );
  };

  // 原文/译文标注
  const getLabel = (type: 'original' | 'translation') => {
    if (language === 'CN') return type === 'original' ? '原文' : '译文';
    if (language === 'DE') return type === 'original' ? 'Original' : 'Übersetzung';
    return type === 'original' ? 'Original' : 'Translation';
  };

  return (
    <div className="min-h-screen bg-gradient-to-b from-[#1C1C1C] to-[#252525]">
      <div className="pt-16 pb-16 relative bg-gradient-to-b from-[#1C1C1C] to-[#1C1C1C]">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 relative">
          <Link to={`/Qiaodong/BPF/workshop/${groupId}`} className="inline-flex items-center text-[#B9AE9A]/60 hover:text-[#B9AE9A] transition-colors duration-300 text-sm font-bauhaus mb-8">
            <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4 mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
            </svg>
            {t('bpf.workshop.group.back_to_group')}
          </Link>
          <div className="text-left">
            <h1 className="text-4xl font-bauhaus text-white tracking-tight mb-4">
              {poet.names?.[poetLang] || poet.names?.zh}
            </h1>
            <p className="text-lg text-white/70 mb-6">
              {poet.bio?.[poetLang] || poet.bio?.zh}
            </p>
          </div>
        </div>
      </div>
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <h2 className="text-2xl font-bauhaus text-white mb-8">{t('bpf.workshop.poet.works')}</h2>
        <div className="space-y-8">
          {poet.poems?.map((poem: any) => (
            <div key={poem.id} className="bg-white/10 rounded-2xl p-6 shadow-lg">
              <div className="flex flex-col md:flex-row gap-6">
                {/* 原文栏 */}
                <div className="flex-1 text-white/80 whitespace-pre-line border-r border-white/20 pr-4 md:pr-8">
                  <div className="text-xs text-white/50 mb-2 text-center md:text-left">{getLabel('original')}</div>
                  {getOriginalTitle(poem) && (
                    <div className="font-bauhaus text-lg md:text-xl font-bold mb-4 text-center md:text-left bg-gradient-to-r from-[#B9AE9A]/30 to-[#8C4233]/30 rounded px-2 py-1 border-b border-white/20">
                      {getOriginalTitle(poem)}
                    </div>
                  )}
                  {poem.content?.original}
                  {poem.translator?.zh && (
                    <div className="text-xs text-white/40 mt-2 text-right">
                      {t('bpf.workshop.poet.translator')}: {poem.translator.zh}
                    </div>
                  )}
                </div>
                {/* 译文栏 */}
                <div className="flex-1 text-white/60 whitespace-pre-line pl-4 md:pl-8">
                  <div className="text-xs text-white/50 mb-2 text-center md:text-left">{getLabel('translation')}</div>
                  {getTranslationTitle(poem) && (
                    <div className="font-bauhaus text-lg md:text-xl font-bold mb-4 text-center md:text-left bg-gradient-to-r from-[#8C4233]/30 to-[#B9AE9A]/30 rounded px-2 py-1 border-b border-white/20">
                      {getTranslationTitle(poem)}
                    </div>
                  )}
                  {poem.content?.translation}
                  {poem.translator?.de && (
                    <div className="text-xs text-white/40 mt-2 text-right">
                      {t('bpf.workshop.poet.translator')}: {poem.translator.de}
                    </div>
                  )}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  )
} 